import { NavigatorV22Impl } from "./navigator";
import { UserInteractionHandlerV2Proxy, } from "./user-interaction-handler-v2";
import { UserInteractionV22, } from "./user-interaction-v2";
import { parsePath } from "./parse-path";
export class UserInteractionServiceV22Impl {
    constructor(logger, historyService, options) {
        this.logger = logger;
        this.historyService = historyService;
        this.options = options;
        this.navigators = new Map();
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        this.actions = new Map();
        historyService.history.listen(() => {
            const path = parsePath(historyService.history.location.pathname);
            this.navigators.forEach((navigator, pathId) => {
                if (path && this.getPathName(pathId) === path.name) {
                    // will execute the navigator with params
                    navigator.notify(path.name, path.params);
                }
                else {
                    // will execute the navigator without params
                    navigator.notifyExit();
                }
            });
        });
    }
    createNavigator(pathId, consumerId) {
        const existingNavigator = this.navigators.get(pathId);
        if (existingNavigator) {
            return existingNavigator;
        }
        const navigator = new NavigatorV22Impl(this.historyService, this.logger, this.getPathName(pathId), consumerId);
        this.navigators.set(pathId, navigator);
        return navigator;
    }
    getNavigatorConsumerId() {
        if (this.historyService.history.location.pathname.length > 1) {
            const currentPath = parsePath(this.historyService.history.location.pathname);
            if (!currentPath) {
                return undefined;
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            return [...this.navigators]
                .filter(([pathId]) => this.getPathName(pathId) === currentPath.name)
                .map(([, navigator]) => navigator.consumerId)
                .find(() => true); // find first
        }
        return undefined;
    }
    getPathName(pathId) {
        if (this.options && this.options.navigatorKeyTranslations) {
            return this.options.navigatorKeyTranslations[pathId] || pathId;
        }
        return pathId;
    }
    /** returns all registered action ids */
    getActions() {
        const list = [];
        this.actions.forEach((action, id) => {
            if (action.registered()) {
                list.push(id);
            }
        });
        return list;
    }
    getOrCreateAction(id) {
        let action = this.actions.get(id);
        if (!action) {
            this.logger.debug(`User interaction with id '${id}' was requested but does not exist.`);
            action = new UserInteractionV22();
            this.actions.set(id, action);
        }
        return action;
    }
    registerV2(id, options) {
        // consumerName is set for feature apps registered by integrator.It is never set for feature services.
        const action = this.getOrCreateAction(id);
        action.updateV2(options);
        return new UserInteractionHandlerV2Proxy(action);
    }
    register(id, options) {
        const action = this.getOrCreateAction(id);
        action.updateV2(options);
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        return new UserInteractionHandlerV2Proxy(action);
    }
    unregister(id) {
        this.logger.debug(`Unregister user interaction with id ${id}`);
        const action = this.actions.get(id);
        if (action) {
            action.update(undefined);
        }
    }
    getV2(id) {
        return new UserInteractionHandlerV2Proxy(this.getOrCreateAction(id));
    }
    get(id) {
        return new UserInteractionHandlerV2Proxy(this.getOrCreateAction(id));
    }
}
//# sourceMappingURL=user-interaction-service-v2.js.map